import { Reveal } from "./Reveal";
import AuditForm from "./AuditForm";

export default function LeadForm() {
  return (
    <section id="forma" data-testid="lead-form-section" className="bg-[#003E75] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <Reveal>
              <h2 className="font-display font-black tracking-tighter leading-[1.02] text-4xl sm:text-5xl lg:text-6xl text-white" data-testid="final-cta-heading">
                Pirms palielināt reklāmas budžetu,{" "}
                <span className="text-[#ED1C27]">pārbaudiet savus banerus un video</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-8 space-y-4 text-white/70 text-base leading-relaxed max-w-lg">
              <p>Iespējams, Jums nav nepieciešams lielāks reklāmas budžets.</p>
              <p>
                Iespējams, daļu no rezultāta var iegūt, uzlabojot kreatīvus, par kuru rādīšanu
                Jūs jau maksājat.
              </p>
              <p className="text-white font-semibold">
                Uzziniet, kur Jūsu baneri un video zaudē pārdošanas potenciālu.
              </p>
            </Reveal>
            <Reveal delay={0.15} className="mt-8">
              <p className="text-xs text-white/50" data-testid="final-qualifiers">
                Gada apgrozījums no €500 000&nbsp;&nbsp;•&nbsp;&nbsp;Reklāmas budžets no
                €2 000/mēn.&nbsp;&nbsp;•&nbsp;&nbsp;Bez maksas&nbsp;&nbsp;•&nbsp;&nbsp;Bez saistībām
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <AuditForm testidPrefix="final-audit-form" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
